import * as angular from 'angular';
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {$agentsFactory} from "../../../agents/$agents.factory";
import {TasksService} from "../../../tasks/services/tasks-service.service";
import {AttachmentsService} from "../../../attachments/services/attachments-service.service";
import {DeliveriesDialogService} from "../../services/deliveries-dialog-service.service";
import {DeliveriesService} from "../../services/deliveries-service.service";
import {ServicesService} from "../../services/services-service.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {Service} from "../../models/service.model";
import {MissingItemModel} from "../../models/missing-item.model";
import {ServiceStatus} from "../../constants/service-status.type";
import {OperationalContactModel} from "../../../commons/angular/models/operational-contact.model";
import {TaskPurposeType} from "../../../commons/types/task-purpose.type";
import {OrdersService} from "../../../orders/services/orders-service.service";
import {MetaDataModel} from "../../../commons/models/meta-data.model";
import {createNewPackageItem, replacePackageItem} from "../../../orders/utils/package-items.util";
import {UuidService} from "../../../commons/services/uuid-service.service";
import {LabelPrintTemplateType} from "../../../commons/types/label-print-template.type";

export class ServiceGroupSelectorCtrl implements IController {
  service: Service;
  serviceMetaData: any;
  taskMetaData: any;

  public subTaskAgentsList: any;
  public taskColorByPurpose: any;
  public attachmentsUrls: any;
  public dynamicColumnsMap: any;
  public hasRelations: boolean;
  public settings: any;
  public expandedSubtasks: any;
  public isAttachmentsExpanded: boolean;
  public isDisableEntityLockState: boolean;
  public editableMetaData?: MetaDataModel;
  public isActiveService: boolean;

  private activeServiceStatuses: ServiceStatus[];
  private relations: any;
  private siteLabels: any;
  public useLegacyServiceTime: boolean;
  public queryPackages: string;
  public isEditingPackages: boolean;
  public editablePackageList?: any[];
  public expendAllPackages: boolean;
  private packageSizes: any[];
  private defaultItemSize: string;

  /* @ngInject */
  constructor(private tasksService: TasksService, private deliveriesService: DeliveriesService, private tasksConstants, private splitService,
              private bringozTimeFilter, private attachmentsService: AttachmentsService, private deliveriesDialogService: DeliveriesDialogService, private $log,
              private $agents: $agentsFactory, private servicesService: ServicesService, private ordersService: OrdersService,
              private $timeout: ITimeoutService, private UUIDService: UuidService) {
    this.siteLabels = this.splitService.getSiteLabels();
    this.taskColorByPurpose = this.tasksConstants.typesToColor;
    this.activeServiceStatuses = [
      ServiceStatus.Unassigned,
      ServiceStatus.Assigned,
      ServiceStatus.Started,
      ServiceStatus.InAuction,
      ServiceStatus.InMarket
    ];
  }

  $onInit() {
    this.expandedSubtasks = {};
    this.isAttachmentsExpanded = true;
    this.settings = this.splitService.getSitePackageDetailsSettings();
    this.isDisableEntityLockState = this.splitService.getDisableEntityLockStateValue();
    this.subTaskAgentsList = {};
    this.attachmentsUrls = [];
    this.isActiveService = this._isActiveService();
    this.dynamicColumnsMap = _.mapKeys(this.service.metaData, (value, key) => {
      return value.key;
    });

    this.useLegacyServiceTime = !this.service.taskList[0].taskSpec.detailedServiceTime;

    const blobNames = _.map(this.service.attachments, 'name');

    if (_.get(this.service, 'attachments.length') && blobNames.length) {
      this.attachmentsService.getAttachmentsUrls(blobNames)
        .then((attachmentsUrls) => {
          this.attachmentsUrls = attachmentsUrls;
          _.forEach(this.attachmentsUrls, (attachment) => {
            attachment.mimeType = this.attachmentsService.getAttachmentsMimeType(attachment.name);
          })
        });

    }
    this.hasRelations = !!_.compact(_.flatMap(this.service.taskList, 'relations')).length;

    this.service.taskList.forEach(task => this.sortSubTasks(task));
  }

  $onChanges(changes) {
    if (changes.service && this.service) {
      this.service.taskList.forEach(task => this.sortSubTasks(task));

      const agentsIdList = [];
      let relations = [];
      _.forEach(this.service.taskList, (t) => {
        relations = relations.concat(t.relations || [])

        _.forEach(t.subTasks, (st) => {
          if (!!st.assignedAgentId) {
            agentsIdList.push(st.assignedAgentId);
          }
        })

      });

      if (agentsIdList.length) {
        this.$agents().$asyncValues(agentsIdList)
          .then((agents) => {
            _.forEach(agents, (a) => {
              this.subTaskAgentsList[a.id] = `${a.user.firstName} ${a.user.lastName}`;
            })
          })
        this.relations = relations;
      }

      this.hasRelations = !!_.compact(_.flatMap(this.service.taskList, 'relations')).length;
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onQueryPackagesChange(query) {
    this.queryPackages = query;
  }

  sortSubTasks(task): void {
    if (!task || !task.subTasks) return;

    task.subTasks.sort((a: any, b: any) => {
      return a.sequenceIndex - b.sequenceIndex;
    });
  }

  onEditMetaData(key: string, value?: string) {
    this.editableMetaData = {key: key, value: value};
  }

  onCancelEditMetaData() {
    this.editableMetaData = undefined;
  }

  onEditableMetaDataValueChange(value) {
    this.editableMetaData.value = value;
  }

  onSaveMetaData(editableMetaData: { key: string, value: string }) {
    const metaDataCopy = angular.copy(this.service.metaData) || [];
    const metaDataIndex = metaDataCopy.findIndex((m: { key: string, value?: string }) => {
      return m.key === editableMetaData.key;
    })
    if (metaDataIndex > -1) {
      metaDataCopy[metaDataIndex] = editableMetaData;
    } else {
      metaDataCopy.push(editableMetaData);
    }
    this._updateMetaData(metaDataCopy)
  }

  onToggleExpand(subTask) {
    this.expandedSubtasks[subTask.id] = !this.expandedSubtasks[subTask.id];
  }

  onToggleAttachments() {
    this.isAttachmentsExpanded = !this.isAttachmentsExpanded;
  }

  onEditIdentification(identification, task, event) {
    this.deliveriesDialogService.editIdentification(this.service, task.id, identification, event)
      .then((updatedService) => {
        this._onServiceChange(updatedService);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onDeleteNote(noteId) {
    this.servicesService.onDeleteServiceNote(this.service.id, noteId);
  }

  onEditTaskServiceTime(taskId: string, serviceTime: number) {
    const payload = {
      legacyServiceTime: serviceTime,
      useLegacyServiceTime: true
    }

    this.tasksService.editTaskServiceTime(taskId, payload)
      .then((updatedTask) => {
        const index = this.service.taskList.findIndex(t => t.id === taskId);
        if (index != -1) {
          this.service.taskList[index] = updatedTask;
        }
      })
  }

  onEditTaskDetailedServiceTime(taskId, detailedServiceTime) {
    const payload = {
      detailedServiceTime: detailedServiceTime,
      useLegacyServiceTime: false
    }

    this.tasksService.editTaskServiceTime(taskId, payload)
      .then((updatedTask) => {
        const index = this.service.taskList.findIndex(t => t.id === taskId);
        if (index != -1) {
          this.service.taskList[index] = updatedTask;
        }
      })
  }

  onEditTaskLocation(task: TaskModel, event?) {
    this.deliveriesDialogService.editLocation(this.service.id, task.taskSpec, this.service.omsOrderReference?.id, event)
      .then((payload: { taskSpec: any, updateOrder: boolean, sendSms: boolean, rePrice: boolean }) => {
        this._editTaskLocation(task.id, payload.taskSpec, payload.updateOrder, payload.sendSms, payload.rePrice);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onEditExtraInfo(taskId, extraInfo, $event) {
    this.deliveriesDialogService.editExtraInfo(extraInfo, $event)
      .then((editedExtraInfo) => {
        this._editTaskExtraInfo(taskId, editedExtraInfo);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onViewSettingsChange(settings) {
    this.settings = settings;
    this.splitService.setSitePackageDetailsSettings(settings);
  }

  onChangeStatus(task, status, $index) {
    this.service.taskList[$index] = task;
  }

  onUnlinkRelatedTask(relation) {
    this.deliveriesDialogService.unlinkRelatedTaskConfirm(this.service, relation)
      .then(() => {
        this.servicesService.unlinkRelatedTask(this.service.id, relation.taskId, relation.relatedTaskId);
      })
  }

  onMissingItemsChange(item) {
    const missingItem = {
      id: item.id,
      dataList: item.missingItems || []
    }

    this.deliveriesDialogService.editMissingItemsByPackageItem(item, missingItem)
      .then((updatedMissingItem: MissingItemModel) => {
        this._updateMissingItem(updatedMissingItem);
      })
  }

  onEditPackages() {
    if (this.isEditingPackages) return;

    this.ordersService.getOrderSettings(this.service.account.id, this.service.serviceType, this.service.pricePlanType)
      .then((orderSettings) => {
        this.packageSizes = orderSettings.itemSizeList;
        this.defaultItemSize = orderSettings.defaultItemSize;
        this._setEditablePackageList();
        this.isEditingPackages = true;
      })
  }

  onAddPackage() {
    const newPackage = createNewPackageItem(this.packageSizes, this.defaultItemSize);
    this.editablePackageList[0].items.push({...newPackage, expended: true});
  }

  onEditablePackageChange(packageItem, index: number) {
    this.editablePackageList[0].items = replacePackageItem(this.editablePackageList[0].items, packageItem, index);
  }

  onResetPackages() {
    this._setEditablePackageList();
  }

  onCancelEditPackages() {
    this.isEditingPackages = false;
    this.editablePackageList = undefined;
  }

  onSavePackages(form) {
    const labelPrintTemplateType = this.splitService.getLabelPrinterTemplateType();

    if (labelPrintTemplateType === LabelPrintTemplateType.Bergstrom) {
      const splitItems = this._splitMultiCountItems(this.editablePackageList[0].items);
      this._suffixDuplicateBarcodes(splitItems);
      this._generateMissingBarcodes(splitItems);
      this.editablePackageList[0].items = splitItems;
    }

    // Let the digest re-run validators on the generated barcodes before checking validity
    this.$timeout(() => {
      form.$setSubmitted(true);
      if (!form.$valid) {
        this.expendAllPackages = true;
        return;
      }

      this._savePackages();
    });
  }

  private _savePackages() {
    const serviceCopy = angular.copy(this.service);
    serviceCopy.packageList = this.editablePackageList;

    this._updateService(serviceCopy)
      .then((updatedService: Service) => {
        if (updatedService) {
          this.onCancelEditPackages();
        }
      })
  }

  onEditOperationalContacts($event) {
    this.deliveriesDialogService.editOperationalContacts(this.service.operationalContacts)
      .then((operationalContacts: OperationalContactModel[]) => {
        this._updateOperationalContacts(operationalContacts);
      })
  }

  // onEditPackageItemAttachment(item, attachmentIndex) {
  //   this.deliveriesDialogService.getAttachment()
  //     .then((updatedAttachment) => {
  //       const itemIndex = _.findIndex(this.service.packageList[0].items, (i: any) => {
  //         return i.id === item.id;
  //       })
  //
  //       if (itemIndex > -1) {
  //         const serviceCopy = angular.copy(this.service);
  //         serviceCopy.packageList[0].items[itemIndex].attachments[attachmentIndex] = updatedAttachment;
  //         this._updateService(updatedAttachment);
  //       }
  //
  //     })
  //     .catch(() => {
  //       this.$log.info('Dialog Closed');
  //     })
  // }
  //
  // Every package with count > 1 becomes `count` packages of count 1 sharing one barcode (made unique by _suffixDuplicateBarcodes)
  private _splitMultiCountItems(items: any[]): any[] {
    return _.flatMap(items, (item, index: number) => {
      const count = Number(item.count) || 1;
      if (count <= 1) {
        return [item];
      }

      const barcode = item.barcode || this._generateBarcode(index);

      return _.times(count, (countIndex: number) => {
        const itemCopy = angular.copy(item);
        itemCopy.count = 1;
        itemCopy.barcode = barcode;
        if (countIndex > 0) {
          itemCopy.id = undefined;
        }
        return itemCopy;
      });
    });
  }

  // Only barcodes that repeat get a suffix (barcode-{occurrenceIndex + 1}); unique barcodes are left untouched
  private _suffixDuplicateBarcodes(items: any[]) {
    const itemsByBarcode = _.groupBy(_.filter(items, 'barcode'), 'barcode');

    _.forEach(itemsByBarcode, (duplicateItems: any[], barcode: string) => {
      if (duplicateItems.length < 2) {
        return;
      }

      duplicateItems.forEach((item, occurrenceIndex: number) => {
        item.barcode = `${barcode}-${occurrenceIndex + 1}`;
      });
    });
  }

  private _generateMissingBarcodes(items: any[]) {
    _.forEach(items, (item, index: number) => {
      if (!item.barcode) {
        item.barcode = this._generateBarcode(index);
      }
    });
  }

  private _generateBarcode(index: number): string {
    return `${this.service.id}-${index}${this.UUIDService.generateShort(3)}`;
  }

  private _setEditablePackageList() {
    this.editablePackageList = angular.copy(this.service.packageList);
    this.expendAllPackages = false;

    // Open the first package for editing, same as pressing its pencil button
    const firstPackage = _.get(this.editablePackageList, '[0].items[0]');
    if (firstPackage) {
      firstPackage.expended = true;
    }
  }

  private _updateService(service) {
    return this.deliveriesService.updateService(service, false)
      .then((updatedService: Service) => {
        // updateService swallows errors and resolves undefined - keep the current service in that case
        if (updatedService) {
          this._onServiceChange(updatedService);
        }
        return updatedService;
      })
  }

  private _editTaskLocation(taskId: string, taskSpec: any, updateOrder?: boolean, sendSms?: boolean, rePrice?: boolean) {
    this.servicesService.updateTaskLocation(this.service.id, taskId, taskSpec, updateOrder, sendSms, rePrice)
      .then((updatedService: Service) => {
        this._onServiceChange(updatedService);
      })
  }

  private _editTaskExtraInfo(taskId: string, editedExtraInfo: string) {
    this.tasksService.editTaskExtraInfo(taskId, editedExtraInfo)
      .then((updatedTask) => {
        const index = this.service.taskList.findIndex(t => t.id === taskId);
        if (index != -1) {
          this.service.taskList[index] = updatedTask;
        }
      })
  }

  private _updateMetaData(metaData: { key: string, value: string }[]) {
    this.deliveriesService.updateServiceMetaData(this.service.id, metaData)
      .then((updatedService: Service) => {
        this.dynamicColumnsMap = _.mapKeys(updatedService.metaData, (value, key) => {
          return value.key;
        });
        this.editableMetaData = undefined;
      })
  }

  private _updateMissingItem(updatedMissingItem: MissingItemModel) {
    this.deliveriesService.updateMissingItem(this.service.id, updatedMissingItem)
      .then((service: Service) => {
        this._onServiceChange(service);
      })
  }

  private _updateOperationalContacts(operationalContacts: OperationalContactModel[]) {
    this.deliveriesService.updateOperationalContacts(this.service.id, operationalContacts)
      .then((service: Service) => {
        this._onServiceChange(service);
      })
  }

  private _onServiceChange(updatedService: Service) {
    this.service = updatedService;
    this.isActiveService = this._isActiveService();
  }

  private _isActiveService() {
    return !!_.includes(this.activeServiceStatuses, this.service?.status);
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceDetailsInfo', {
    bindings: {
      service: '<',
      serviceMetaData: '<',
      taskMetaData: '<',
    },
    template: require('./service-details-info.html').default,
    controller: ServiceGroupSelectorCtrl
  });
